import { hyper } from "hyperhtml";
let $tingle = require("tingle.js");
import "select2";
import createSnippet from "./tephra_manager/createSnippet";
import { GlobalRender } from "./utils";
import tagsManager from "./tephra_manager/manageTags";
import Tabs from "./tabs";

const TephraManager = (function() {
  function TephraManager() {
    this.init();
  }

  TephraManager.prototype.init = function() {};

  TephraManager.addSnippet = async () => {
    if (!document.getElementById("tephra-nav")) {
      Panes.root.getItemsById("navStack")[0].addChild({
        id: "tephra",
        type: "component",
        componentName: "tephra",
        reorderEnabled: false,
        componentState: { label: "tephra-nav", id: "tephra-nav" },
        editor_id: "tree"
      });
    } else {
      Tabs.setActiveById("tephra");
    }
  };

  TephraManager.createSnippet = createSnippet;

  TephraManager.getTephraSnippetNewForm = () => {
    return new Promise((res, reject) => {
      $.ajax({
        type: "get",
        dataType: "html",
        data: {
          theme_id: CodeEditor.Main.themeId()
        },
        url: "/api/v1/tephra_snippets/new",
        success: function(data) {
          res(data);
        },
        error: function(xhr, ajaxOptions, thrownError) {
          reject(thrownError);
        }
      });
    });
  };

  TephraManager.createTephraSnippet = (family, newFamily, reference, prebuilt) => {
    const form = new FormData();
    form.append("tephra_snippet[family]", family);
    form.append("tephra_snippet[family_other]", newFamily);
    form.append("tephra_snippet[reference]", reference);
    form.append("tephra_snippet[prebuilt]", prebuilt);
    form.append("utf8", "✓");
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "post",
        dataType: "json",
        url: "/api/v1/tephra_snippets?theme_id=" + CodeEditor.Main.themeId(),
        data: form,
        cache: false,
        processData: false,
        contentType: false,
        success: function(data) {
          if (data.success === true) {
            CodeEditor.Tree.reload();
            resolve(data);
          } else {
            CodeEditor.Tree.reload();
            alert("Teprha snippet creation faild");
            reject(data);
          }
        }
      });
    });
  };

  // TephraManager.downloadTephras = async () => {
  //   let jszip_lib = await loadAsyncJS("https://cdnjs.cloudflare.com/ajax/libs/jszip/3.1.5/jszip.min.js", {
  //     id: "jszip"
  //   });
  //   let zip = new JSZip();
  // };

  TephraManager.getAllTephras = async () => {
    const map = new Map();
    const data = {};
    const tephras = tree.findAll(i => i.data.path && !i.folder && i.data.path.includes("tephra"));
    for (const item of tephras) {
      const [node, content] = await new Promise(res => {
        CodeEditor.Main.loadFile(
          item,
          "asset",
          item.data.path,
          (a, b) => res([a.data.path.replace(/^tephra\//, ""), b]),
          true
        );
      });
      data[node] = content;
    }
    const entries = Object.entries(data);
    for (const [key, val] of entries) {
      const [family] = key.split("/");
      const hasit = map.has(family);
      const snippetKey = key
        .split("/")
        .slice(1)
        .join("/");
      if (hasit) {
        const current = map.get(family);
        map.set(family, { ...current, [snippetKey]: val });
      } else {
        map.set(family, { [snippetKey]: val });
      }
    }
    return Object.fromEntries(map.entries());
  };
  TephraManager.snippetUsage = function(node) {
    let modal = new $tingle.modal({
      closeMethods: [],
      footer: true,
      stickyFooter: true
    });

    modal.open();
    modal.setContent("<p>Loading...</p>");

    modal.addFooterBtn("Close", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      modal.destroy();
    });

    $.ajax({
      type: "get",
      dataType: "html",
      data: {
        theme_id: CodeEditor.Main.themeId()
      },
      url: "/api/v1/tephra_snippets/" + node.data.secure_random + "/usage",
      success: function(data) {
        $(".tingle-modal-box__content").html(data);
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError);
      }
    });
  };

  TephraManager.editSnippet = function(node) {
    let modal = new $tingle.modal({
      closeMethods: [],
      footer: true,
      stickyFooter: true
    });

    modal.open();
    modal.setContent("<p>Loading...</p>");

    modal.addFooterBtn("Update", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {
      let form = document.getElementById("tephra_snippet_theme_form");
      let formData = new FormData(form);

      $.ajax({
        type: "patch",
        dataType: "json",
        url: "/api/v1/tephra_snippets/" + node.data.secure_random + "?theme_id=" + CodeEditor.Main.themeId(),
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        success: function(data) {
          if (data.success === true) {
            modal.destroy();
            return true;
          } else {
            $(".tingle-modal-box__content").html(data.form);
            return true;
          }
        },
        error: function(xhr, ajaxOptions, thrownError) {
          alert(thrownError);
        }
      });
    });

    modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      modal.destroy();
    });

    $.ajax({
      type: "get",
      dataType: "html",
      data: {
        theme_id: CodeEditor.Main.themeId()
      },
      url: "/api/v1/tephra_snippets/" + node.data.secure_random + "/edit",
      success: function(data) {
        $(".tingle-modal-box__content").html(data);
        $("#tephra_snippet_asset_ids").select2();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(thrownError);
      }
    });
  };

  TephraManager.addSnippetToTheme = snippetID => {
    const fd = new FormData();
    fd.append("utf8", "✓");
    fd.append("tephra_snippet_theme[tephra_snippet_id]", snippetID);

    fetch("/api/v1/tephra_snippets/snippet_theme?theme_id=" + CodeEditor.Main.themeId(), {
      method: "POST",
      headers: new Headers({ "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") }),
      credentials: "include",
      body: fd
    }).then(CodeEditor.Tree.reload);
  };
  TephraManager.detachSnippet = node => {
    TephraManager.deleteSnippet(node, true);
  };
  TephraManager.deleteSnippet = function(node, detach_from_theme) {
    detach_from_theme = detach_from_theme === true ? true : false;
    let modal = new $tingle.modal({
      closeMethods: [],
      footer: true,
      stickyFooter: true
    });

    modal.open();
    modal.setContent("<p>Are you sure you want delete this snippet from your theme?</p>");

    modal.addFooterBtn("Delete", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {
      let file_path = CodeEditor.Tree.getNodePath(node);
      const secure_random = node.data.secure_random;
      const url = "/api/v1/tephra_snippets/" + (detach_from_theme ? "detach" : secure_random);
      const notification = CodeEditor.UI.notif();
      $.ajax({
        type: "delete",
        url: url,
        data: {
          secure_random: secure_random,
          theme_id: CodeEditor.Main.themeId()
        },
        success: function() {
          // if (data.success === true) {
          document.getElementById(file_path) && Tabs.close(file_path);
          node.remove();
          node = null;
          return console.log("Delete confirmed!");
          // }
        },
        error: function({ responseJSON }, ajaxOptions, thrownError) {
          notification.error({
            message: `<p>Error while deleting "${node.data.path}", The server responded with this Error</p> <br/>
            <pre style="white-space:pre; color: #fff">${JSON.stringify(responseJSON, null, "\t")}</pre>
          `,
            timeout: 10000,
            progressBar: false,
            position: "bottomRight"
          });

          console.log(thrownError);
        }
      });
      modal.destroy();
    });

    modal.addFooterBtn("Cancel", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      modal.destroy();
    });
  };

  TephraManager.SearchFolder = node => {
    if (node.folder) {
      CodeEditor.SearchFolder.attachNode(node);
      CodeEditor.SearchFolder.show();
    }
  };

  TephraManager.ManageTags = tagsManager;
  return TephraManager;
})();

export default TephraManager;
